<div class="calculator">
  <div class="calculator-header">
    <h5 class="calculator-title">Calculator</h5>
    <button type="button" class="btn-mode" (click)="toggleMode()" [title]="isScientific ? 'Standard mode' : 'Scientific mode'">
      {{ isScientific ? 'Standard' : 'Scientific' }}
    </button>
  </div>

  <div class="calculator-display" [title]="display">{{ display }}</div>

  <div class="calculator-buttons">
    @if (isScientific) {
    <div class="scientific-row">
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('sin')">sin</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('cos')">cos</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('tan')">tan</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('log')">log</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('ln')">ln</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('sqrt')">√</button>
      <button type="button" class="btn-calc btn-func" (click)="power()">x^y</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('π')">π</button>
      <button type="button" class="btn-calc btn-func" (click)="appendScientific('e')">e</button>
      <button type="button" class="btn-calc btn-func" (click)="append('(')">(</button>
      <button type="button" class="btn-calc btn-func" (click)="append(')')">)</button>
    </div>
    }

    <div class="button-row">
      <button type="button" class="btn-calc btn-op" (click)="sqrt()">&radic;</button>
      <button type="button" class="btn-calc btn-op" (click)="clear()">C</button>
      <button type="button" class="btn-calc btn-op" (click)="clearEntry()">CE</button>
      <button type="button" class="btn-calc btn-op" (click)="backspace()">⌫</button>
    </div>
    <div class="button-row">
      <button type="button" class="btn-calc" (click)="append('7')">7</button>
      <button type="button" class="btn-calc" (click)="append('8')">8</button>
      <button type="button" class="btn-calc" (click)="append('9')">9</button>
      <button type="button" class="btn-calc btn-op" (click)="append('/')">÷</button>
    </div>
    <div class="button-row">
      <button type="button" class="btn-calc" (click)="append('4')">4</button>
      <button type="button" class="btn-calc" (click)="append('5')">5</button>
      <button type="button" class="btn-calc" (click)="append('6')">6</button>
      <button type="button" class="btn-calc btn-op" (click)="append('*')">×</button>
    </div>
    <div class="button-row">
      <button type="button" class="btn-calc" (click)="append('1')">1</button>
      <button type="button" class="btn-calc" (click)="append('2')">2</button>
      <button type="button" class="btn-calc" (click)="append('3')">3</button>
      <button type="button" class="btn-calc btn-op" (click)="append('-')">−</button>
    </div>
    <div class="button-row">
      <button type="button" class="btn-calc btn-zero" (click)="append('0')">0</button>
      <button type="button" class="btn-calc" (click)="append('.')">.</button>
      <button type="button" class="btn-calc btn-op" (click)="append('+')">+</button>
    </div>
    <div class="button-row">
      <button type="button" class="btn-calc btn-equals" (click)="equals()">=</button>
    </div>
  </div>
</div>
